/**
 * @prettier
 */
import ArrowUpIcon from "./components/arrow-up"
import ArrowDownIcon from "./components/arrow-down"
import ArrowIcon from "./components/arrow"
import CloseIcon from "./components/close"
import LockIcon from "./components/lock"
import UnlockIcon from "./components/unlock"

const IconsPlugin = () => ({
  components: {
    ArrowUpIcon,
    ArrowDownIcon,
    ArrowIcon,
    CloseIcon,
    LockIcon,
    UnlockIcon,
  },
})

export default IconsPlugin
